import { Component } from '@angular/core';
import { ProductGridItemComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-grid-item',
  templateUrl: './product-grid-item.component.html',
  styleUrl: './product-grid-item.component.scss',
  standalone: false,
})
export class CustomProductGridItemComponent extends ProductGridItemComponent {}
